export default __webpack_public_path__ + "static/media/boy2.c4d821d7.png";